<template>
    <div class="type_check_box" v-loading="loading">
        <el-dialog title="立即咨询" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
                <div class="type_check1">

                    <div class="check_item" :class="{ 'check_item_ac': type1_ac == item.type }" v-for="(item, index) in type1"
                        :key="index" @click="handle_type1(item, index)">
                        <div class="checl_img_ac" v-if="type1_ac == item.type">
                            <img src="@/assets/img/index/legal/check_ac.png" alt="">
                        </div>
                        <div class="check_title">{{ item.title }}</div>
                        <div class="check_imgs">
                            <div class="imgs" v-if="type1_ac != item.type"><img :src="item.imgs" alt=""></div>
                            <div class="imgs" v-if="type1_ac == item.type"><img :src="item.imgs_ac" alt=""></div>
                        </div>
                    </div>
                </div>
                <div class="type_check2">
                    <el-radio v-model="type2_ac" :label="item.title" v-for="(item, index) in type2"
                        :key="index">{{ item.title }}</el-radio>
                </div>


                <div class="btn_flex">
                    <div class="bnts1" @click="handle_changes">确定</div>
                </div>
            </div>
        </el-dialog>


        <el-dialog title="选择携带订单" :visible.sync="dialogVisible2" :close-on-click-modal="false"
            :close-on-press-escape="false" :before-close="handleClose2">
            <div class="dialog_box2">
                <div>
                    <el-table :data="order_list">
                        <el-table-column prop="date" label="订单号" width="200">
                            <template slot-scope="scope">
                                 <el-radio v-model="order_ac" :label="scope.row.id">{{ scope.row.order_sn }}</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pro.title" label="服务">
                        </el-table-column>
                        <el-table-column prop="address" label="详情">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="$router.push('/user_order/order_detial?id='+scope.row.id)">订单详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="btn_flex">
                    <div class="bnts1" @click="handle_end">确定</div>
                    <div class="bnts2" @click="handleClose2">取消</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            shop_type: 1,//1个人法务 2企业法务
            shop_type2: 1,//1预约律师 2在线委托
            order_type: '',//1法律-在线咨询 2法律-预约律师 3立即咨询 4个人法务-预约律师 5个人法务-在线委托 6企业法务-预约律师 7企业法务-在线委托
            dialogVisible: false,//显示隐藏
            type1_ac: '1',
            type1: [
                {
                    title: '简单咨询',//
                    type: 1,
                    imgs: require('../../assets/img/index/legal/check_1_1.png'),
                    imgs_ac: require('../../assets/img/index/legal/check_1_2.png'),

                },
                {
                    title: '详细咨询',
                    type: 2,
                    imgs: require('../../assets/img/index/legal/check_2_1.png'),
                    imgs_ac: require('../../assets/img/index/legal/check_2_2.png'),
                }
            ],
            type2_ac: '诉讼服务',
            type2: [
                {
                    title: '诉讼服务',//
                },
                {
                    title: '非诉讼服务',//
                }
            ],
            items: {},




            dialogVisible2: false,
            order_list: [],
            order_ac:'',
            jf_order_id:'',

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_order_list()
    },
    methods: {
        get_order_list() {
            this.loading = true
            this.$api("myOrderListCopy", {
                // status:'1',
                page: 1,
                limit: 999,
			}, "get").then((res) => {
                this.loading = false
                console.log('我的订单列表',res)
                if (res.code == 1) {
                    this.order_list = res.data.data
                     
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleClose() {
            this.dialogVisible = false

        },
        handleClose2() {
            this.dialogVisible2 = false
            this.order_ac=0

        },


        handle_open(item, i, i2,jf_order_id) {
            console.log('item', item)
            console.log('i', i)
            console.log('i2', i2)
            this.shop_type = i
            this.shop_type2 = i2
            this.items = item
            if(jf_order_id){
                this.jf_order_id=jf_order_id
            }
            // shop_type:1,//1个人法务 2企业法务 i
            // shop_type2:1,//1预约律师 2在线委托 i2
            // 1法律-在线咨询 2法律-预约律师 3立即咨询 4个人法务-预约律师 5个人法务-在线委托 6企业法务-预约律师 7企业法务-在线委托	
            if (i == 1) {//个人法务
                if (i2 == 1) {//预约律师
                    this.order_type = 4
                }
                if (i2 == 2) {//在线委托
                    this.order_type = 5
                }
            }
            if (i == 2) {//企业法务
                if (i2 == 1) {//预约律师
                    this.order_type = 6
                }
                if (i2 == 2) {//在线委托
                    this.order_type = 7
                }
            }
            console.log('order_type', this.order_type)

            this.dialogVisible = true
        },
        handle_changes(){
            if(this.type1_ac==1){
                this.dialogVisible2=true
            }else{
                this.order_ac=0
                this.handle_end()
            }
        },
        handle_end() {
            if (this.type2_ac == '诉讼服务') {
                this.$router.push({
                    path: '/legal_lawyer_index',
                    query: {

                        title_num: this.type1_ac,//1简单咨询 2详情咨询
                        type2_ac: 1,//1诉讼服务 2非诉讼服务
                        pro_id: this.items.id,
                        order_type: this.order_type,
                        lawyer_id: this.$route.query.lawyer_id || 0,
                        order_id:this.order_ac||'',
                        jf_order_id:this.jf_order_id||''

                    }
                })
            }
            if (this.type2_ac == '非诉讼服务') {

                this.$router.push({
                    path: '/no_legal_lawyer_index',
                    query: {
                        title_num: this.type1_ac,//1简单咨询 2详情咨询
                        type2_ac: 2,//1诉讼服务 2非诉讼服务
                        pro_id: this.items.id,
                        order_type: this.order_type,
                        lawyer_id: this.$route.query.lawyer_id || 0,
                        order_id:this.order_ac||'',
                        jf_order_id:this.jf_order_id||''
                    }
                })
            }
        },
        handle_type1(item, index) {
            this.type1_ac = item.type
        },


    },

}
</script>
<style scoped lang="less">
.type_check_box {
    /deep/.el-dialog__wrapper {
        .el-dialog {
            width: 580px;

            .el-dialog__header {
                background: #F7F7F7;
            }

            .el-dialog__body {
                .dialog_box {
                    .type_check1 {
                        width: 370px;
                        margin: auto;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .check_item {
                            width: 158px;
                            height: 138px;
                            background: #FFFFFF;
                            border-radius: 6px 6px 6px 6px;
                            border: 1px solid #B8C4D1;
                            position: relative;
                            cursor: pointer;

                            .check_title {
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                text-align: center;
                                padding-top: 16px;
                            }

                            .check_imgs {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                padding-top: 14px;

                                .imgs {
                                    width: 72px;
                                    height: 64px;
                                }
                            }

                            .checl_img_ac {
                                position: absolute;
                                right: 0;
                                bottom: 0;

                                img {
                                    width: 37px;
                                    height: 37px;
                                }
                            }
                        }

                        .check_item_ac {
                            border-color: #377CFD;
                        }
                    }

                    .type_check2 {
                        width: 370px;
                        margin: auto;
                        padding-top: 30px;
                    }


                    .btn_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 67px;


                        .bnts1 {
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left: 20px;
                        }
                    }
                }

                .dialog_box2 {


                    .btn_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 67px;


                        .bnts1 {
                            width: 100px;
                            height: 40px;
                            background: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left: 20px;
                        }
                        .bnts2{
                            width: 100px;
                            height: 40px;
                            background: #FFFFFF;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            border: 1px solid #377CFD;
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>